import styled from "styled-components";

import { shimmer } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

interface IFallbackBackgroundProps {
  backgroundColor: string;
}

export const FallbackBackground = styled.div<IFallbackBackgroundProps>`
  border-radius: 4px;

  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const NexusGroupImageContainer = styled.div`
  position: relative;

  ${FallbackBackground} {
    aspect-ratio: inherit;
  }

  img[data-is-loading="true"] {
    background: linear-gradient(90deg, #2f2f2f 25%, #424242 50%, #2f2f2f 75%);
    background-size: 200% 100%;

    animation: ${shimmer} 1.5s infinite ease-in-out;
  }
`;
